


const recursiveCleanup = (cleanupArray, toClear, obj) => {
    if (typeof obj === 'object' && !!obj) {
        Object.keys(obj).forEach((k) => {
            if (k === toClear) {
                delete obj[k];
            }else if (typeof obj[k] === 'object' && !Array.isArray(obj[k])) {
                recursiveCleanup(cleanupArray, toClear, obj[k]);
            } else if(Array.isArray(obj[k])){
                for(const e of obj[k]){
                   recursiveCleanup(cleanupArray, toClear, e);
                }
            }
        })
    }
}

export const clearGqlTypename = (obj) => {
    const _obj = JSON.parse(JSON.stringify(obj));
    const TO_CLEAR = '__typename';
    const objectsToClear = [];
    recursiveCleanup(objectsToClear, TO_CLEAR, _obj);
    return _obj;
}

export const clearOfProperty = (obj, property) => {
    const _obj = JSON.parse(JSON.stringify(obj));
    const TO_CLEAR = property;
    const objectsToClear = [];
    recursiveCleanup(objectsToClear, TO_CLEAR, _obj);
    return _obj;
}